import React from "react";
import { IconButton } from "@material-ui/core";
import { ArrowBack, ArrowBackIos } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import useStyles from "./styles";

const BackButton = ({ 
	onClick, 
	position = "relative",
	top = 0,
	left = 0,
	style = {},
	className = "",
	icon = "arrowBack", 
	showBackground = true,
	...props 
}) => {
	const classes = useStyles();
	const history = useHistory();

	const handleClick = (onClick) => {
		if (onClick) {
			onClick();
		} else {
			history.goBack();
		}
	};

	const defaultStyle = {
		position,
		zIndex: 10,
		top,
		left,
		...(showBackground && {
			backgroundColor: "rgba(0, 0, 0, 0.4)",
			color: "#fff",
		}),
		...style,
	};

	const IconComponent = icon === "arrowBackIos" ? ArrowBackIos : ArrowBack;

	return (
		<IconButton
			onClick={() => handleClick(onClick)}
			className={`${showBackground ? classes.backButton : ""} ${className}`}
			style={defaultStyle}
			{...props}>
			<IconComponent style={{ fontSize: "18px" }}/>
		</IconButton>
	);
};

export default BackButton;

